import { apiClientGeral } from '@/plugins/axios'

export default {
  getRamaisLazy() {
    return apiClientGeral().get('/ramais/lazy')
  },
}
